import type { Link } from '@wix/public-schemas'
import type { PhoneLinkData } from './linksDataTypes'

export const handlePhoneLink = (linkData: PhoneLinkData): Link => {
	const { phoneNumber } = linkData
	return { href: `tel:${phoneNumber}` }
}
